import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=8cfd633e&scoped=true&lang=pug"
import script from "./FormCard.vue?vue&type=script&lang=ts"
export * from "./FormCard.vue?vue&type=script&lang=ts"
import style0 from "./FormCard.vue?vue&type=style&index=0&id=8cfd633e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfd633e",
  null
  
)

export default component.exports